import { render } from "./ContingentForm.vue?vue&type=template&id=596fcc4a&scoped=true"
import script from "./ContingentForm.vue?vue&type=script&lang=js"
export * from "./ContingentForm.vue?vue&type=script&lang=js"

import "./ContingentForm.vue?vue&type=style&index=0&id=596fcc4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596fcc4a"]])

export default __exports__